export default "__VITE_ASSET__Bdr1lQO$__"